export const veeduriaTypes = {
    VEEDURIA_SAVE_START: '[Veeduria] SAVE_START',
    VEEDURIA_SAVE_COMPLETE: '[Veeduria] SAVE_COMPLETE',
    VEEDURIA_SAVE_ERROR: '[Veeduria] SAVE_ERROR',
    VEEDURIA_DOWNLOAD_START: '[Veeduria] DOWNLOAD_START',
    VEEDURIA_DOWNLOAD_COMPLETE: '[Veeduria] DOWNLOAD_COMPLETE',
    VEEDURIA_DOWNLOAD_ERROR: '[Veeduria] DOWNLOAD_ERROR'
}